export default "__VITE_ASSET__BKiuQBUE__"